import Konva from 'konva';
import { MutableRefObject, useCallback, useEffect, useRef } from 'react';
import { MapImageConfig } from '../../model/mapConfigSerialization';
import { WarehouseMapTool } from '../../model/types';

interface Args {
  activeTool: WarehouseMapTool;
  imageTransform: MapImageConfig;
  backgroundRef: MutableRefObject<Nullable<Konva.Image>>;
}

interface Api {
  backgroundTransformerRef: MutableRefObject<Nullable<Konva.Transformer>>;
}

export const useImageTransform = ({ activeTool, imageTransform, backgroundRef }: Args): Api => {
  const backgroundTransformerRef = useRef<Konva.Transformer>(null);
  const shiftHeldRef = useRef(false);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      shiftHeldRef.current = event.shiftKey;
      backgroundTransformerRef.current?.rotationSnaps(event.shiftKey ? [0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180] : []);
    };
    const onKeyUp = (event: KeyboardEvent): void => {
      shiftHeldRef.current = event.shiftKey;
      backgroundTransformerRef.current?.rotationSnaps(event.shiftKey ? [0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180] : []);
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, []);

  const attachTransformer = useCallback((): void => {
    const transformer = backgroundTransformerRef.current;
    const background = backgroundRef.current;
    if (!transformer) return;

    if (activeTool === WarehouseMapTool.EDIT_BACKGROUND && !imageTransform.locked && background) {
      transformer.nodes([background]);
      transformer.resizeEnabled(false);
      transformer.rotateEnabled(true);
      transformer.rotationSnaps(shiftHeldRef.current ? [0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180] : []);
    } else {
      transformer.nodes([]);
    }
    transformer.getLayer()?.batchDraw();
  }, [activeTool, backgroundRef, imageTransform.locked]);

  useEffect(() => {
    attachTransformer();
  }, [attachTransformer, imageTransform.x, imageTransform.y, imageTransform.rotation]);

  return { backgroundTransformerRef };
};
